import { Component, Input, OnInit, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';
import { addWebp } from '@digilize/shared/utils/helpers';
import { Product, PRODUCT_LABELS, ProductInstance, ProductType, Shop } from '@shared/definitions';

@Component({
  selector: 'lib-card-product',
  templateUrl: './card-product.component.html',
  styleUrls: ['../card.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class CardProductComponent implements OnInit {
  @Input() product: Product;
  @Input() shop: Shop;
  @Input() displayShopName: boolean;
  @Input() slider: boolean;
  ProductInstances = ProductInstance;
  ProductType = ProductType;
  constructor() {}

  ngOnInit(): void {}

  fromProductLabels(label): boolean {
    return PRODUCT_LABELS.some((obj) => obj.value === label);
  }

  get addWebp() {
    return addWebp();
  }
}
